import { Controller } from "@hotwired/stimulus"
import { renderStreamMessage } from "@hotwired/turbo"

// Keeps the series-scope dialog's Continue control pointed at whichever
// action the checked radio implies (TASK-238.2, doc-39 §4, board "Series
// scope dialog"). 238.2's real build, copied in (see
// Schedules::VisitsController's class comment) — `update()` now writes
// BOTH `data-slideover-turbo-frame-src-value` (edit/cancel's Continue, a
// link handed to modal#closeAndOpenSlideover) and `data-url` (reschedule/
// reassign's Continue, TASK-238.3's own `continuePatch` below): the view
// renders only ONE of the two controls per intent, so writing the attribute
// the other one would have used is harmless, not a second code path.
export default class extends Controller {
  static targets = ["radio", "continue"]

  connect() {
    this.update()
  }

  update() {
    const checked = this.radioTargets.find((radio) => radio.checked)
    if (!checked || !this.hasContinueTarget) return

    this.continueTarget.setAttribute("data-slideover-turbo-frame-src-value", checked.dataset.url)
    this.continueTarget.setAttribute("data-url", checked.dataset.url)
  }

  // Reschedule/reassign's own Continue (TASK-238.3): there is no slideover
  // to hand off to — the pending change already came from the drag, not a
  // form — so this re-sends the SAME turbo-stream-only PATCH the drop
  // itself sent, just with `scope` filled in this time (the query string
  // already carries the pending change and `return_to`,
  // visits_helper.rb#scope_continue_url). Closes the modal once the stream
  // has rendered, same as a normal mutation closing whatever opened it.
  async continuePatch() {
    const url = this.continueTarget.dataset.url
    if (!url) return

    const token = document.querySelector('meta[name="csrf-token"]')?.content
    const response = await fetch(url, {
      method: "PATCH",
      headers: { Accept: "text/vnd.turbo-stream.html", "X-CSRF-Token": token }
    })
    const html = await response.text()
    renderStreamMessage(html)
    window.dispatchEvent(new CustomEvent("modal:close-requested"))
  }
}
